<!-- ============================================================== -->
<!-- Bread crumb and right sidebar toggle -->
<!-- ============================================================== -->

@if (pageInfo()?.isShowBreadcrumb) {
  <div class="c-breadcrumb">
    @if (pageInfo()?.isShowBackButton) {
      <button
        type="button"
        class="btn btn-sm btn-light o-button-action mb-0 mr-3"
        (click)="volver()"
      >
        <span class="material-symbols-rounded">arrow_back</span>
      </button>
    }

    <h4 class="c-breadcrumb__title">
      {{ pageInfo()?.title }}
    </h4>

    <span class="mx-2">
      <span class="material-symbols-rounded mt-2" style="font-size: 24px">
        chevron_right
      </span>
    </span>

    <ul class="c-breadcrumb__content ps-0">
      @for (url of pageInfo()?.urls; track url; let last = $last) {
        @if (!last) {
          <li class="c-breadcrumb__text c-breadcrumb__text--active">
            <a [routerLink]="url.url">{{ url.title }}</a>
            <span class="material-symbols-rounded m-2"> chevron_right </span>
          </li>
        }

        @if (last) {
          <li class="c-breadcrumb__text">
            {{ url.title }}
          </li>
        }
      }
    </ul>
  </div>
}

<!-- @if(pageInfo()?.isShowBreadcrumb){
<div class="c-breadcrumb">
  @if(pageInfo()?.isShowBackButton){
  <button
    type="button"
    class="btn btn-sm btn-light o-button-action mb-0 mr-3"
    (click)="volver()"
  >
    <span class="material-symbols-rounded">arrow_back</span>
  </button>
  }
  <h4 class="c-breadcrumb__title">
    {{ pageInfo()?.title }}
  </h4>
  <span class="mx-2">
    <span class="material-symbols-rounded mt-2" style="font-size: 24px"
      >chevron_right</span
    >
  </span>
  <ul class="c-breadcrumb__content ps-0">
    @for(url of pageInfo()?.urls; track url  ){
    <ng-template  let-last="last">
      @if(!last){
      <li class="c-breadcrumb__text c-breadcrumb__text--active">
        <a [routerLink]="url.url">{{ url.title }}</a>
        <span class="material-symbols-rounded m-2">chevron_right</span>
      </li>}
      @if(last){
       <li class="c-breadcrumb__text">{{ url.title }}</li>
        }
    </ng-template>
  }
  </ul>
</div>
} -->
